var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobalLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 0a2.9 2.9 0 012.9 2.9v2h-1.8v-2a1.1 1.1 0 00-1.1-1.1H2.9a1.1 1.1 0 00-1.1 1.1v12A1.1 1.1 0 002.9 16h6.5a1.1 1.1 0 001.1-1.1v-2h1.8v2a2.9 2.9 0 01-2.9 2.9H2.9A2.9 2.9 0 010 14.9v-12A2.9 2.9 0 012.9 0h6.5z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.14 8.84l-3.71 4.21-1.35-1.19 1.772-2.01H6.35v-1.8h9.694L14.08 5.82l1.35-1.19 3.71 4.21z",
    fill: "#000"
  })));
}
export default SvgIconGlobalLogout;